<template>
  <div class="PersonelIoInfo">
    <section-personel-search-panel :accessTo="17" @search="search" />
    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon v-if="list.length > 0" @click="print" color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div class="vacationList">
        <div v-if="list.length > 0">
          <personel-io-info-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <personel-io-info-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import PersonelIoInfoListMob from "../../components/personelOperationReport/PersonelIoInfoList/PersonelIoInfoListMob.vue";
import PersonelIoInfoListWeb from "../../components/personelOperationReport/PersonelIoInfoList/PersonelIoInfoListWeb.vue";
import SectionPersonelSearchPanel from "../../components/personelOperationReport/SectionPersonelSearchPanel.vue";
import ResultType from "../../model/ResultType";
export default {
  components: {
    SectionPersonelSearchPanel,
    PersonelIoInfoListWeb,
    PersonelIoInfoListMob,
  },
  data() {
    return {
      list: [],
      beginDate: "",
      endDate: "",
      perno:''
    };
  },
  methods: {
    search(searchParams) {
      this.beginDate = searchParams.beginDate;
      this.endDate = searchParams.endDate;
      this.perno = searchParams.perno;
      
      console.log(searchParams);
      var params = searchParams;
      this.$store.dispatch("GetPersonIoInfo", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data;
        }
      });
    },
    print() {
      var dp = this.perno
      let routeData = this.$router.resolve({
        name: "rpIoInfo",
        query: { BD: this.beginDate, ED: this.endDate, dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
    onClick() {},
  },
};
</script>

<style>
</style>